import React, { useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEDITOR_CONFIG } from '../../utils/Constants';
// import SendMedia from './sentmedia';

export default function CustomCkeditor(props) {
  const {
    onChange = () => { },
    setFieldValue = () => { },
    config = {},
    fieldname
  } = props;
  const editorId = props.id || fieldname;

  // Ref to store the editor instance for external access (media button)
  const editorInstanceRef = useRef(null);



  const CKEDITOR_CONFIG_LOCAL = {
    ...CKEDITOR_CONFIG,
    ...config
  };

  // Map CKEditor 4 config to CKEditor 5 where possible
  const editorConfig = {
    licenseKey: 'GPL',
    // Basic toolbar configuration - ClassicEditor has a default, but we can override:
    // toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
    simpleUpload: {
      uploadUrl: CKEDITOR_CONFIG_LOCAL.filebrowserUploadUrl,
      headers: CKEDITOR_CONFIG_LOCAL.fileTools_requestHeaders
    }
  };

  return (
    <div className="custom-ckeditor-wrapper">
      <CKEditor
        editor={ClassicEditor}
        data={props?.data || props?.value || ""}
        config={editorConfig}
        onReady={editor => {
          // You can store the "editor" and use when it is needed.
          editorInstanceRef.current = editor;
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(event, editor);
          setFieldValue(editorId, data);
        }}
      />
    </div>
  )
}
 